"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

const DialogContext = /*#__PURE__*/(0, _react.createContext)({});

if (process.env.NODE_ENV !== 'production') {
  DialogContext.displayName = 'DialogContext';
}

var _default = DialogContext;
exports.default = _default;